import { of as observableOf, Observable } from 'rxjs';

import { first, catchError } from 'rxjs/operators';
// #TODO 30-04-2018_FG Terminer les interfaces

import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { SharedData } from "libraries/hotel/shared-data";
import { QuotationService } from "libraries/hotel/services/quotation/quotation.service";
import { UrlHelperService } from "libraries/service/url-helper/url-helper.service";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { EStayPermissions } from "libraries/enums/e-stay-permissions";
import { flatMap } from "rxjs/internal/operators";

@Injectable()
export class QuotationPageResolver implements Resolve<any> {
    constructor(
        private router: Router,
        private sharedData: SharedData,
        private quotationService: QuotationService,
        private urlHelperService: UrlHelperService,
        private readonly permissionResourceService: PermissionResourceService,
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot) {
        const sharedQuotation: any = this.sharedData.getCurrentData('quotation');

        if (sharedQuotation) {
            return sharedQuotation;
        }
        const quotationKey: string = route.params.quotation;
        if (quotationKey) {
            const key: string = quotationKey.startsWith('htl_') ? quotationKey : this.urlHelperService.decodeUrlPart(quotationKey);
            return this.permissionResourceService.hasPermission(EStayPermissions.SHARED_HOST_SHOW)
                .pipe(
                    flatMap((canShowHost: boolean) => {
                        return this.quotationService.getQuotationById(key)
                            .pipe(
                                catchError((error: Error): any => {
                                    this.router.navigate(['iaqobohotel', 'search']);

                                    return observableOf(null);
                                }), first(),);
                    })
                );


        }
        this.router.navigate(['iaqobohotel', 'search']);

    }
}
